// // import React, { useState } from 'react'
// // import { motion, AnimatePresence } from "framer-motion";
// // import { RxCross2 } from "react-icons/rx";
// // import img1 from "../../assets/furniture/img1.jpg";
// // import img2 from "../../assets/furniture/img2.jpg";
// // import img3 from "../../assets/furniture/img3.jpg";
// // import img4 from "../../assets/furniture/img4.jpg";
// // import img5 from "../../assets/furniture/img5.jpg";
// // import img6 from "../../assets/furniture/img6.jpg";
// // import img7 from "../../assets/furniture/img7.jpg";
// // import img8 from "../../assets/furniture/img8.jpg";

// // const cocktailsItems = [
// //     {
// //         name: "Vintage Colonial Design",
// //         description:
// //             "Featuring a vintage colonial design with curved armrests and turned legs, This Planter Chair offers superior comfort and aesthetic appeal to your living space.",
// //         image: img1,
// //         regprice: "79,000",
// //         disprice: "40,000"

// //     },
// //     {
// //         name: "Modern Rattan Accent Chair",
// //         description:
// //             "Premium Burma teak Wood & Cane Weaving Ideal for Homes & Restaurant",
// //         image: img2,
// //         regprice: "30,000",
// //         disprice: "25,000"
// //     },
// //     {
// //         name: "Modern Wooden TV Cabinet",
// //         description:
// //             "Modern Wooden TV Cabinet – Sleek & Functional ✔ Premium Solid Wood Construction✔ Spacious Storage & Open Shelves ✔ Sleek & Contemporary Design.",
// //         image: img7,
// //         regprice: "79,000",
// //         disprice: "40,000"
// //     },
// //     {
// //         name: "Luxury Wooden Dining Set ",
// //         description:
// //             " A Touch of Royalty Made from premium solid wood. Contact for Discounted Price.",
// //         image: img4,
// //         regprice: "79,000",
// //         disprice: "40,000"
// //     },
// //     {
// //         name: "Modern Wooden TV Cabinet",
// //         description:
// //             " Modern Wooden TV Cabinet – Sleek & Functional ✔ Premium Solid Wood Construction✔ Spacious Storage & Open Shelves ✔ Sleek & Contemporary Design.",
// //         image: img5,
// //         regprice: "79,000",
// //         disprice: "40,000"
// //     },
// //     {
// //         name: "Royal Wooden Sofa Set",
// //         description:
// //             "Classic Elegance for Your Home. making it perfect for both traditional and modern interiors.",
// //         image: img3,
// //         regprice: "79,000",
// //         disprice: "40,000"
// //     },

// // ];


// // const Furnitures = () => {
// //     const [selectedCocktail, setSelectedCocktail] = useState(null);

// //     return (
// //         <div>
// //             <div className="bg-white min-h-screen mt-20 mb-10 font-basefont">
// //                 {/* Header */}
// //                 <header className=" text-black py-5 mb-10 text-center overflow-hidden relative">
// //                     <div className="lg:m-0 m-1 font-basefont">
// //                         <h1 className="lg:text-3xl text-4xl font-semibold font-basefont ">
// //                             Furnitures
// //                         </h1>

// //                     </div>
// //                 </header>

// //                 {/* Cocktail Grid */}
// //                 <div className="grid grid-cols-1 font-basefont sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8 px-5 sm:px-20">
// //                     {cocktailsItems.map((cocktail, index) => (
// //                         <motion.div
// //                             key={index}
// //                             className="text-center cursor-pointer"
// //                             initial={{ opacity: 0, scale: 0.8 }}
// //                             animate={{ opacity: 1, scale: 1 }}
// //                             transition={{ duration: 0.6, }}
// //                             whileHover={{
// //                                 scale: 1.05,
// //                                 // rotate: 5,
// //                                 transition: { duration: 0.3 },
// //                             }}
// //                             onClick={() => setSelectedCocktail(cocktail)} // Open modal with selected cocktail
// //                         >
// //                             <img
// //                                 src={cocktail.image}
// //                                 alt={cocktail.name}
// //                                 className="mx-auto mb-4 rounded-lg"
// //                             />
// //                             <h2 className="text-lg font-bold">{cocktail.name}</h2>
// //                             {/* <p className="text-gray-500">{cocktail.description}</p> */}
// //                         </motion.div>
// //                     ))}
// //                 </div>
// //             </div>

// //         </div>
// //     )
// // }

// // export default Furnitures


// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import FurnData from '../../data/Data';

// const Furnitures = () => {
//     const navigate = useNavigate();

//     return (
//         <div className="bg-white min-h-screen mt-20 mb-10">
//             <header className="text-center py-5 mb-10">
//                 <h1 className="text-4xl font-semibold">Furnitures</h1>
//             </header>

//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 px-5 sm:px-20">
//                 {FurnData.map((item) => (
//                     <motion.div
//                         key={item.id}
//                         className="text-center cursor-pointer"
//                         initial={{ opacity: 0, scale: 0.8 }}
//                         animate={{ opacity: 1, scale: 1 }}
//                         whileHover={{ scale: 1.05 }}
//                         transition={{ duration: 0.3 }}
//                         onClick={() => navigate(`/furniture/${item.id}`)}
//                     >
//                         <img
//                             src={item.image || 'https://via.placeholder.com/300x200?text=No+Image'}
//                             alt={`Furniture ${item.id}`}
//                             className="mx-auto mb-4 rounded-lg shadow-lg"
//                         />
//                         <h2 className="text-lg font-basefont font-semibold">{item.primary_material}</h2>
//                     </motion.div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default Furnitures;


import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import FurnData from '../../data/Data';

const Furnitures = () => {
    const [selectedCategory, setSelectedCategory] = useState("All");
    const navigate = useNavigate();

    // Filter furniture data based on the selected category
    const filteredFurnitures = selectedCategory === "All"
        ? FurnData
        : FurnData.filter(item => item.category === selectedCategory);

    return (
        <div className="bg-white min-h-screen font-basefont mt-20 mb-10">
            <header className="text-center py-5 mb-10">
                <h1 className="text-4xl font-semibold">Furnitures</h1>
            </header>

            <div className="text-center mb-8 font-basefont">
                <button
                    className={`px-4 py-2 mx-2 rounded-md ${selectedCategory === "All" ? "bg-gray-400" : "bg-gray-200"}`}
                    onClick={() => setSelectedCategory("All")}
                >
                    All
                </button>
                <button
                    className={`px-4 py-2 mx-2 rounded-md ${selectedCategory === "Chair" ? "bg-gray-400" : "bg-gray-200"}`}
                    onClick={() => setSelectedCategory("Chair")}
                >
                    Chairs
                </button>
                <button
                    className={`px-4 py-2 mx-2 rounded-md ${selectedCategory === "Sofa" ? "bg-gray-300" : "bg-gray-100"}`}
                    onClick={() => setSelectedCategory("Sofa")}
                >
                    Sofas
                </button>
                <button
                    className={`px-4 py-2 mx-2 rounded-md ${selectedCategory === "TV" ? "bg-gray-300" : "bg-gray-100"}`}
                    onClick={() => setSelectedCategory("TV")}
                >
                    TV Cabinets
                </button>
                <button
                    className={`px-4 py-2 mx-2 rounded-md ${selectedCategory === "Bench" ? "bg-gray-300" : "bg-gray-100"}`}
                    onClick={() => setSelectedCategory("Bench")}
                >
                    Benches
                </button>
            </div>

            {/* Furniture Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 px-5 sm:px-20">
                {filteredFurnitures.map((item) => (
                    <motion.div
                        key={item.id}
                        className="text-center cursor-pointer"
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.3 }}
                        onClick={() => navigate(`/furniture/${item.id}`)}
                    >
                        <img
                            src={item.image || 'https://via.placeholder.com/300x200?text=No+Image'}
                            alt={`Furniture ${item.id}`}
                            className="mx-auto mb-4 rounded-lg h-72 w-full object-cover"
                        />
                        <h2 className="text-lg font-basefont font-semibold">{item.name}</h2>
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default Furnitures;
